import { flow } from 'lodash/fp'
import { getRootState } from '../../../store/shared'

export const MarginRateAdjustmentFeatureSliceKey =
  'features.marginRateAdjustment'
export const getMarginRateAdjustmentFeatureState = flow(
  getRootState,
  (x) => x[MarginRateAdjustmentFeatureSliceKey]
)
